import moment from 'moment'
import Vue from 'vue'
import axios from 'axios'

import store from '~/store'
import {
  map,
  pick,
  unset,
  kSort,
  clone,
  maxBy,
  pluck,
  merge,
  filter,
  remove,
  values,
  assign,
  sortBy,
  indexOf,
  isArray,
  getKeys,
  flatten,
  replace,
  orderBy,
  uniqWith,
  interval,
  isNumber,
  getWeeks,
  isString,
  findWith,
  isObject,
  endsWith,
  getTypeof,
  hasObject,
  getObject,
  precision,
  findIndex,
  mergeWith,
  getValues,
  getUnique,
  getSubstr,
  arrayFrom,
  endOfHour,
  isFunction,
  whereNotIn,
  noReactive,
  isBooleand,
  regExpTest,
  notInMatch,
  replaceAll,
  startOfHour,
  insertArray,
  getFileName,
  whereInWith,
  getTheFirst,
  isUndefined,
  arrayCombine,
  randomString,
  getBoolValue,
  setTransform,
  sortedIndexBy,
  getDifference,
  newDateFormat,
  getKeysObject,
  checkVariable,
  getLastIndexOf,
  whereNotInWith,
  getObjectValue,
  getValueNumber,
  getArrayValues,
  differenceWith,
  getAmountOfKeys,
  getNumberFormat,
  localDatepicker,
  getSeparateDate,
  concatEcmascript,
  createListNumber,
  arrayCombineWith,
  toYYYYMMDDString,
  getUniqueWithKey,
  getTheFirstWithout,
  momentCustomFormat,
  getFirstOccurrence,
  getDifferenceInDays,
  getParameterOfTheUrl,
  compareArrangementWith,
  getDifferenceInMinutes,
  getAllAssociatedValues,
  getNumberFormatPercent,
  getUniqueWithKeyWithout,
  checkVariableEcmascript,
  formattedValueRetracement,
  getTheFirstOccurrenceByKey,
  getFirstOccurrenceInObject,
  createTheParametersOfTheUrl,
  getTheDateGivenInDateFormat,
  asyncTakeCareOfCompressingOnly,
  asyncGetNaturalSizeImage,
} from './helper'
import {
  createForm,
  waitInAWhile,
  newAssignment,
  determineModule,
  creationOfColumns,
  determineInspection,
  captureDataToRevert,
  getFilterInformation,
  determinesModuleInspection,
  determinesInspectionAction,
  determinePermissionInOption,
  calculateTotalSmallCashService,
  calculateTotalInvoicesAndChecks,
} from './helperService'
import {
  referenceContract,
} from '../pages/requests/requestService'
import {
  inspectBillAndPayments,
  handleTheLoadingOfInvoiceFiles,
} from '../pages/all_contracts/contractService'
import {
  cleanUpInputs,
} from '../pages/administrations/user/userService'

const { connect } = require('./notificationHelper')
const { objectToFormData } = require('./objectToFormData')

const helperMixin = {
  data() {
    return {
      Echo: null,
    }
  },
  methods: {
    /**
     * @return {*}
     */
    connectionToPusherJs() {
      return connect()
    },
    localDatepicker(locale) {
      return localDatepicker(locale)
    },
    /**
     * @param {Array|String} permits
     * @return {Boolean}
     */
    determinesInspectionAction(permits) {
      return determinesInspectionAction(permits)
    },
    /**
     * @param {Array}
     * @return {Boolean}
     */
    determineInspection(permits) {
      return determineInspection(permits)
    },
    /**
     * Determines if a user can perform actions
     * in a certain module
     * @param {Array} permits
     * @param {Object} contractStates
     * @param {String|Array} status
     * @return {Bool}
     */
    determinePermissionInOptionContract(permits, contractStatus, statuteVerify) {
      return determinePermissionInOption(permits, contractStatus, statuteVerify)
    },
    /**
     * @param {Array} permits
     * @return {Boolean}
     */
    determinesModuleInspection(permits) {
      if (isArray(permits) && permits.length === 0) {
        return true
      }

      return determinesModuleInspection(permits)
    },
    /**
     * @param {Array} permits
     * @param {String} defaultRoute
     * @return {String|Boolean}
     */
    determineModule(permits, defaultRoute) {
      if (checkVariable(defaultRoute) && isString(defaultRoute) && defaultRoute !== '#') {
        return defaultRoute
      }
      if (isArray(permits) && permits.length === 0) {
        return defaultRoute
      }
      let route = determineModule(permits)
      const verifyType = route.indexOf('/')
      if (verifyType !== -1 && this.isString(route)) {
        if (checkVariable(defaultRoute) && this.isNumber(defaultRoute)) {
          route = `${route}/${defaultRoute}?token=${store.getters.authToken}`
        } else {
          route = `${route}?token=${store.getters.authToken}`
        }
      }

      return route
    },
    /**
     * @param {Number} money
     * @return {String}
     */
    getNumberFormat(money) {
      return getNumberFormat(money)
    },
    /**
     * @param {Array} collections
     * @param {String} key
     * @return {Number}
     */
    calculateTotalInvoicesAndChecks(collections, key) {
      return calculateTotalInvoicesAndChecks(collections, key)
    },
    /**
     * @param {Array} collections
     * @param {String} key
     * @return {String}
     */
    totalRequestPerPage(collections, key) {
      return getNumberFormat(this.calculateTotalInvoicesAndChecks(collections, key))
    },
    /**
     * @param {*} params
     */
    noReactive(params) {
      return noReactive(params)
    },
    /**
     * @param {Object} params
     */
    getFilterInformation(params) {
      return this.noReactive(getFilterInformation(params))
    },
    /**
     * @return {String}
     */
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    /**
     * @param {Date} date
     * @return {String|NaN}
     */
    toYYYYMMDDString(date) {
      return toYYYYMMDDString(date)
    },
    /**
     * @param {*} value
     * @return {Boolean}
     */
    isBooleand(value) {
      return isBooleand(value)
    },
    /**
     * @param {Boolean|String} value
     * @return {Boolean}
     */
    getBoolValue(value) {
      return getBoolValue(value)
    },
    /**
     * @param {*} value
     * @return {Boolean}
     */
    isObject(value) {
      return isObject(value)
    },
    /**
     * @param {*} value
     * @return {Boolean}
     */
    isArray(value) {
      return isArray(value)
    },
    /**
     * @param {*} value
     * @return {Boolean}
     */
    isString(value) {
      return isString(value)
    },
    /**
     * @param {*} value
     * @return {Boolean}
     */
    checkVariable(...value) {
      return checkVariableEcmascript(value)
    },
    /**
     * @param {*} value
     * @return {Boolean}
     */
    isUndefined(value) {
      return isUndefined(value)
    },
    /**
     * @param {Number} value
     */
    generateRandomNumber(value) {
      return randomString(value)
    },
    /**
     * @param {Object} form
     * @param {Array} rows
     * @return {Object}
     */
    handleTheLoadingOfInvoiceFiles(form, rows) {
      return handleTheLoadingOfInvoiceFiles(form, rows)
    },
    /**
     * @param {Object} form
     * @return {Object}
     */
    getReference(form) {
      return referenceContract(form)
    },
    /**
     * @param {Object} obj
     * @param {Function} fd
     * @param {*} pre
     * @return {Object}
     */
    objectToFormData(obj, fd, pre) {
      return objectToFormData(obj, fd, pre)
    },
    /**
     * @return {Object}
     */
    transformRequest() {
      return {
        transformRequest: [
          function (data) {
            return objectToFormData(data)
          },
        ],
      }
    },
    /**
     * @param {Object} form
     * @param {String} url
     * @return {Object}
     */
    async postMethodShipping(form, url) {
      return await form.post(url, this.transformRequest())
    },
    /**
     * @param {Object} form
     * @param {String} url
     * @return {Object}
     */
    async patchMethodShipping(form, url) {
      return await form.patch(url)
    },
    /**
     * @param {Array} datos
     * @return {Array}
     */
    getUnique(datos) {
      return getUnique(datos)
    },
    /**
     * @param {Array} datos
     * @param {String|Number}
     * @return {Array|Object}
     */
    getUniqueWithKey(datos, key) {
      return getUniqueWithKey(datos, key)
    },
    /**
     * @param {Array} datos
     * @param {String|Number} value
     * @return {Mixed}
     */
    getFirstOccurrence(datos, value) {
      return getFirstOccurrence(datos, value)
    },
    /**
     * @param {Array} datos
     * @param {String|Array} value
     * @return {Array}
     */
    pluck(datos, pull) {
      return pluck(datos, pull)
    },
    /**
    * Contrae un arreglo de matrices en un unico arreglo plano.
    * @param {Array} array
    * @return {Array}
    */
    flatten(array) {
      return flatten(array)
    },
    /**
     * @param {Object} object
     * @return {Array}
     */
    values(object) {
      return values(object)
    },
    /**
     * @param {Array} datos
     * @param {Boolean} unique
     * @return {Array}
     */
    getKeys(datos, unique) {
      return getKeys(datos, unique)
    },
    /**
     * @param {Array} objects
     * @param {Function} iteratee
     * @return {Number}
     */
    maxBy(objects, iteratee) {
      return maxBy(objects, iteratee)
    },
    /**
     * @param {Object} datos
     * @return {Array}
     */
    arrayFrom(datos) {
      return arrayFrom(datos)
    },
    /**
     * Devuelve el numero en el formato establecido
     * en la función (20.40%)
     * @param {Number}
     * @return {String}
     */
    getNumberFormatPercent(number) {
      return getNumberFormatPercent(number)
    },
    /**
     * @param {Array} datos
     * @param {Array} header
     * @return {Array}
     */
    arrayCombine(datos, header) {
      return arrayCombine(datos, header)
    },
    /**
     * @param {Array} datos
     * @param {Array} header
     * @return {Array}
     */
    arrayCombineWith(datos, header) {
      return arrayCombineWith(datos, header)
    },
    /**
     * @param {Array|Object} value
     * @return {Number}
     */
    getAmountOfKeys(value) {
      return getAmountOfKeys(value)
    },
    /**
     * @param {Object} object
     * @param {Object} sources
     * @param {Function} customizer
     * @return {Object}
     */
    mergeWith(object, sources, customizer) {
      return mergeWith(object, sources, customizer)
    },
    /**
     * @param {Object} object
     * @param {Object} other
     */
    merge(object, other) {
      return merge(object, other)
    },
    /**
     * @param {Array} array
     * @param  {Array} other
     * @return {Array}
     */
    concat(array, other) {
      return concatEcmascript(array, other)
    },
    /**
     * @param {Object} object
     * @param  {...any} sources
     * @return {Object}
     */
    assign(object, sources) {
      return assign(object, sources)
    },
    /**
     * @param {Array} datos
     * @param {String|Number} value
     */
    findIndex(datos, value) {
      return findIndex(datos, value)
    },
    /**
     * @param {Array} datos
     * @param {Function} predicate
     * @param {Number} fromIndex
     */
    findWith(datos, value, fromIndex) {
      return findWith(datos, value, fromIndex)
    },
    /**
     *
     * @param {Array|Object} datos
     * @param {Object|String|Number} value
     * @return {Mixed}
     */
    getFirstOccurrenceInObject(datos, value) {
      return getFirstOccurrenceInObject(datos, value)
    },
    /**
     * @param {Array|Object} datos
     * @param {Object|String|Number} value
     * @param {String} key
     * @return {Mixed}
     */
    getTheFirstOccurrenceByKey(datos, value, key) {
      return getTheFirstOccurrenceByKey(datos, value, key)
    },
    /**
     * @param {Number} number
     * @param {Number} decimal
     * @return {Number}
     */
    precision(number, decimal) {
      return precision(number, decimal)
    },
    /**
     * @param {Array} datos
     * @return {Mixed}
     */
    getTheFirst(datos) {
      if (!this.isArray(datos)) {
        return null
      }

      const first = getTheFirst(datos)
      if (this.checkVariable(first) && this.isArray(first)) {
        return this.checkVariable(first[0]) ? first[0] : null
      }

      return null
    },
    /**
     * @param {Object} datos
     * @param {String} key
     * @return {Mixed}
     */
    getObjectValue(datos, key) {
      return getObjectValue(datos, key)
    },

    /**
     * @param {Array} columnsDefault
     * @return {Array}
     */
    creationOfColumns(columnsDefault) {
      return creationOfColumns(columnsDefault)
    },
    /**
     * @param {Object} datos
     * @retir
     */
    newAssignment(datos) {
      return newAssignment(datos)
    },
    /**
     * @param {Array} datos
     * @param {Mixed} value
     * @param {String} key
     * @return {Mixed}
     */
    getAllAssociatedValues(datos, value, key) {
      return getAllAssociatedValues(datos, value, key)
    },
    /**
     * @param {Number} value
     * @return {Number}
     */
    getValueNumber(value) {
      return getValueNumber(value)
    },
    /**
     * @param {Number} timer
     */
    waitInAWhile(timer) {
      return waitInAWhile(timer)
    },
    /**
     * @param {Array} datos
     * @return {Number}
     */
    calculateTotalSmallCashService(datos) {
      return calculateTotalSmallCashService(datos)
    },
    /**
     * @param {Object} data
     */
    toJson(data) {
      return JSON.stringify(data)
    },
    /**
     * @param {Object} data
     * @return {Number}
     */
    getObjectSize(data) {
      return checkVariable(data) ? Object.keys(data).length : 0
    },
    /**
     * @param {Array} rows
     * @param {Array} checks
     * @return {Promise}
     */
    async takeCareOfVerifyingPayment(rows, checks) {
      const self = this

      return new Promise(resolve => {
        if (self.checkVariable(rows) && self.isArray(rows)) {
          rows.forEach(columns => {
            if (self.checkVariable(columns) && self.isArray(columns)) {
              columns.forEach(column => {
                const first = this.getTheFirstOccurrenceByKey(checks, column.id, 'id')
                if (this.checkVariable(first) && this.getValueNumber(first.aprobado) === 1) {
                  self.$set(column, 'aprobado', true)
                }
                if (this.checkVariable(first) && this.getValueNumber(first.aprobado) === 0) {
                  self.$set(column, 'aprobado', false)
                }
              })
            }
          })
          resolve(true)
        }
      })
    },
    async logout() {
      await this.$store.dispatch('logout')
      this.$router.push({ name: 'login' })
    },
    /**
     * @param {Object} form
     */
    cleanUpInputs(form) {
      cleanUpInputs(form)
    },
    /**
     * @param {Object} form
     * @return {Object}
     */
    createBaseForm(form) {
      return createForm(form)
    },
    /**
     * @param {String} number
     * @return {Number}
     */
    formattedValueRetracement(number) {
      return formattedValueRetracement(number)
    },
    /**
     * @param {String} date
     * @param {String|Array} format
     * @return {moment}
     */
    momentCustomFormat(date, format) {
      return momentCustomFormat(date, format)
    },
    /**
     * @param {moment|String} date
     * @return {Object}
     */
    getSeparateDate(date) {
      return getSeparateDate(date)
    },
    /**
     * @param {moment|String} date
     * @return {Date}
     */
    getTheDateGivenInDateFormat(date) {
      return getTheDateGivenInDateFormat(date)
    },
    /**
     *
     * @param {Array} datos
     * @param {Function} predicate
     * @return {Array}
     */
    remove(datos, predicate) {
      return remove(datos, predicate)
    },
    /**
     * @param {Array}
     * @return {Array}
     */
    clone(datos) {
      return clone(datos)
    },
    /**
     * @param {Array} defaultRows
     * @param {Array} datos
     * @return {Array}
     */
    inspectBillAndPayments(defaultRows, datos) {
      return inspectBillAndPayments(defaultRows, datos)
    },
    /**
     * @param {Array} datos
     * @param {String|Number} values
     * @param {Array|String} keys
     * @return {Array}
     */
    whereNotIn(datos, values, keys) {
      return whereNotIn(datos, values, keys)
    },
    /**
     * @param {Array} datos
     * @param {String|Number} values
     * @param {Array|String} keys
     * @return {Array}
     */
    whereNotInWith(datos, values, keys) {
      return whereNotInWith(datos, values, keys)
    },
    /**
     * @param {Array} datos
     * @param {Object|String|Number} values
     * @return {Array}
     */
    whereInWith(datos, values) {
      return whereInWith(datos, values)
    },
    /**
     * Crear los parámetros correctos que serán
     * enviado usando petición GET
     * @param {Object} options
     * @return {String}
     */
    createTheParametersOfTheUrl(options) {
      return createTheParametersOfTheUrl(options)
    },
    /**
     * Crea un objeto con los parametros de una url.
     * Example: ?ejemplo=3
     * @param {String} url
     * @return {Object}
     */
    getParameterOfTheUrl(url) {
      return getParameterOfTheUrl(url)
    },
    getWeeks(month) {
      return getWeeks(month)
    },
    /**
     * @param {Object} values
     * @param {String} date
     */
    setDateFormat(values, date, key) {
      if (!this.isObject(values)) {
        return
      }
      const moment = this.momentCustomFormat(date, 'YYYY-MM-DD')
      this.$set(values, key, moment.format('YYYY-MM-DD'))
    },
    /**
     * @param {String} date
     * @return {Date?}
     */
    setSelectedDate(date) {
      const moment = this.momentCustomFormat(date, 'YYYY-MM-DD')
      const dateObject = this.getSeparateDate(moment)
      if (this.isObject(dateObject)) {
        const { day, month, year } = dateObject
        return new Date(year, month, day)
      }

      return null
    },
    /**
     * @param {String} pattern
     * @param {String} test
     * @return {Boolean}
     */
    regExpTest(pattern, test) {
      return regExpTest(pattern, test)
    },
    /**
     * @param {*} value
     * @return {Boolean}
     */
    isNumber(value) {
      return isNumber(value)
    },
    /**
     * @param {Boolean} loading
     * @return {Promise}
     */
    setInterval(loading) {
      return interval(loading)
    },
    /**
     * @param {Array} datos
     * @param {Function} comparator
     * @return {Array}
     */
    uniqWith(datos, comparator) {
      return uniqWith(datos, comparator)
    },
    replaceSearchList(f) {
      if (this.checkVariable(f.column) && this.checkVariable(f.column.replace) && this.isArray(f.column.replace)) {
        const result = this.whereInWith(f.column.replace, { operator: f.operator.name })
        const first = this.getTheFirst(result)
        if (this.checkVariable(first) && this.checkVariable(first.name)) {
          this.$set(f.column, 'name', first.name)
        }
      }

      return f
    },
    replaceListObject(f) {
      if (f.operator.component === 'list') {
        if (this.isObject(f.query_1)) {
          this.$set(f, 'query_1', this.getObjectValue(f.query_1, 'value'))
        }
        if (this.isObject(f.query_2)) {
          this.$set(f, 'query_2', this.getObjectValue(f.query_2, 'value'))
        }
      }

      return f
    },
    createFilterForUrl(path) {
      let f = {}
      let query = localStorage.getItem(this.replaceAll(`filter-index-${path}-query`, '/', ''))
      if (this.checkVariable(query)) {
        f = { ...f, ...JSON.parse(query) }
      }
      const filterCandidates = localStorage.getItem(this.replaceAll(`filter-index-${path}-filterCandidates`, '/', ''))
      if (this.checkVariable(filterCandidates)) {
        const filters = JSON.parse(filterCandidates)
        filters.forEach((filter, i) => {
          filter = this.replaceSearchList(filter)
          filter = this.replaceListObject(filter)
          if (filter && filter.column && filter.column.type === 'datepicker') {
            const { withBetween } = filter.column
            let format = 'YYYY-MM-DD'
            if (this.checkVariable(withBetween) && this.isBooleand(withBetween) === true) {
              format = 'YYYY-MM-DD HH:mm:ss'
              if (!this.checkVariable(filter.query_2) && ['equal_to', 'not_equal_to'].indexOf(filter.operator.name) !== -1) {
                this.$set(filter, 'query_2', filter.query_1)
                this.$set(filter.operator, 'name', 'between')
              }
            }
            if (filter.query_1) {
              this.$set(filter, 'query_1', this.startOfHour(filter.query_1, format).format(format))
            }

            if (filter.query_2) {
              this.$set(filter, 'query_2', this.endOfHour(filter.query_2, format).format(format))
            }
          }

          f[`f[${i}][column]`] = filter.column.name
          f[`f[${i}][operator]`] = filter.operator.name
          f[`f[${i}][query_1]`] = filter.query_1
          f[`f[${i}][query_2]`] = filter.query_2
        })
      }

      return f
    },
    /**
     * @param {String} path
     * @return {Object}
     */
    createAdvancedFilter(path) {
      let newQuery = {}
      const query = localStorage.getItem(this.replaceAll(`filter-index-${path}-query`, '/', ''))
      const filterCandidates = localStorage.getItem(this.replaceAll(`filter-index-${path}-filterCandidates`, '/', ''))
      if (this.checkVariable(query)) {
        newQuery = { ...newQuery, ...JSON.parse(query) }
      }
      if (this.checkVariable(filterCandidates)) {
        const filter = JSON.parse(filterCandidates)
        if (this.isArray(filter)) {
          const allFilter = { f: {} }
          filter.forEach((f, i) => {
            f = this.replaceSearchList(f)
            f = this.replaceListObject(f)
            allFilter['f'][i] = {
              column: this.checkVariable(f.column) ? f.column.name : null,
              operator: this.checkVariable(f.operator) ? f.operator.name : null,
              query_1: f.query_1,
              query_2: f.query_2,
            }
          })
          newQuery = { ...newQuery, ...allFilter }
        } else {
          newQuery = { ...newQuery, ...filter }
        }
      }

      return newQuery
    },
    /**
     * @param {String} value
     * @param {String} searchString
     * @return {Number}
     */
    getLastIndexOf(value, searchString) {
      return getLastIndexOf(value, searchString)
    },
    getIndexOf(datos, value, fromIndex) {
      return indexOf(datos, value, fromIndex)
    },
    /**
     * @param {Array} opened
     * @param {Number} id
     * @return {Array}
     */
    setToggle(opened, id) {
      const index = this.getIndexOf(opened, id)
      if (index !== -1) {
        opened.splice(index, 1)
      } else {
        opened.push(id)
      }

      return opened
    },
    /**
     * @param {HTMLElement|File} inputField
     * @param {Number} clientWidth
     * @param {Number} clientHeight
     */
    asyncTakeCareOfCompressingOnly(inputField, clientWidth, clientHeight, useOriginalName = false) {
      return asyncTakeCareOfCompressingOnly(inputField, clientWidth, clientHeight, useOriginalName)
    },
    /**
     * @param {FileList} files
     * @return {Promise}
     */
    asyncGetNaturalSizeImage(files) {
      return asyncGetNaturalSizeImage(files)
    },
    renderUrl(url) {
      if (!this.checkVariable(url)) {
        return ''
      }

      const { appUrl } = window.config
      if (this.regExpTest(appUrl, url) === true) {
        return url
      }

      const subUrl = url.replace(/\bpublic\b/, '')

      return `${appUrl}/storage${subUrl}`
    },
    renderUrlWeb(url) {
      if (!this.checkVariable(url)) {
        return ''
      }

      const { appUrl } = window.config
      if (this.regExpTest(appUrl, url) === true) {
        return url
      }

      return `${appUrl}${url}`
    },
    /**
     * @param {String} originalPhone
     * @return {String}
     */
    getPanamaCellNumber(originalPhone) {
      return /^(507)/.test(originalPhone) ? originalPhone : `507${originalPhone}`
    },
    /**
     * @param {Number} number
     * @param {String} type
     * @return {Array}
     */
    createListNumber(number, type) {
      return createListNumber(number, type)
    },
    /**
     * @param {Array|Object} datos
     * @param {Function} predicate
     * @return {Array}
     */
    filter(datos, predicate) {
      return filter(datos, predicate)
    },
    /**
     * @param {String} root
     * @param {String} delimiter
     * @return {String}
     */
    getFileName(root, delimiter) {
      return getFileName(root, delimiter)
    },
    verifyClientDocument(uri) {
      return this.getIndexOf(['png', 'jpg', 'jpeg'], this.getFileName(uri, '.'))
    },
    /**
     * @param {Object} object
     * @param {Array|string} path
     * @param {*} value
     */
    getObject(object, path, value) {
      return getObject(object, path, value)
    },
    /**
     * @param {Object} object
     * @param {Array|string} path
     */
    hasObject(object, path) {
      return hasObject(object, path)
    },
    /**
     * @param {Object} datos
     * @param {String|Array} paths
     * @return {Object}
     */
    pick(datos, paths) {
      return pick(datos, paths)
    },
    /**
     * @param {Array} array
     * @param {string} key
     */
    kSort(datos, key) {
      return kSort(datos, key)
    },
    /**
     * @param {Object} object
     * @return {Array}
     */
    getKeysObject(object) {
      return getKeysObject(object)
    },
    /**
     * @param {Array} matched
     * @param {Number} index
     * @param {*} item
     */
    insertArray(matched, index, item) {
      return insertArray(matched, index, item)
    },
    /**
     * @param {String} value
     * @param {String} searchString
     * @return {String}
     */
    getSubstr(value, searchString) {
      return getSubstr(value, searchString)
    },
    /**
     * @param {String} value
     * @param {RegExp|String} regex
     * @param {String|Function} newSubStr
     * @return {String}
     */
    replace(value, regex, newSubStr) {
      return replace(value, regex, newSubStr)
    },
    /**
     * @param {String} value
     * @param {RegExp|String} regex
     * @param {String|Function} newSubStr
     * @return {String}
     */
    replaceAll(value, regex, newSubStr) {
      return replaceAll(value, regex, newSubStr)
    },
    /**
     * @param {*} value
     * @return {Boolean}
     */
    isFunction(value) {
      return isFunction(value)
    },
    /**
     * @param {Array|Object} datos
     * @param {Function|String} predicate
     * @return {Array}
     */
    map(datos, predicate) {
      return map(datos, predicate)
    },
    /**
     * @param {Array} datos
     * @return {Array}
     */
    getValues(datos) {
      return getValues(datos)
    },
    /**
     * @param {Array} datos
     * @param {Boolean?} withUniqueKey
     * @param {String?} match
     * @return {Array}
     */
    getUniqueWithKeyWithout(datos, withUniqueKey, match) {
      return getUniqueWithKeyWithout(datos, withUniqueKey, match)
    },
    /**
     * @param {Array} datos
     * @param {String} match
     * @return {Array}
     */
    notInMatch(datos, match) {
      return notInMatch(datos, match)
    },
    /**
     * @param {String} date
     * @param {String} type
     * @return {Number}
     */
    getDifference(date, type) {
      return getDifference(date, type)
    },
    /**
     * @param {String} date
     * @return {Number}
     */
    getDifferenceInDays(date) {
      return getDifferenceInDays(date)
    },
    /**
     * @param {String} date
     * @return {Number}
     */
    getDifferenceInMinutes(date) {
      return getDifferenceInMinutes(date)
    },
    /**
     * Invierte la fecha dada.
     * @param {String} date
     * @return {String}
     */
    newDateFormat(date) {
      return newDateFormat(date)
    },
    /**
     * @param {Object} datos
     * @param {String} value
     * @param {String} text
     * @return {Array}
     */
    getArrayValues(datos, value, text) {
      return getArrayValues(datos, value, text)
    },
    /**
     * Formato para usar en lista
     * @return {Array}
     */
    getPersonGender() {
      return [
        { 'value': 'hombre', 'text': 'Hombre' },
        { 'value': 'mujer', 'text': 'Mujer' },
      ]
    },
    /**
     * Formato para usar en lista
     * @return {Array}
     */
    getPersonalMaritalStatus() {
      return [
        { 'value': 'soltero (a)', 'text': 'Soltero' },
        { 'value': 'casado (a)', 'text': 'Casado' },
        { 'value': 'unido (a)', 'text': 'Unido' },
        { 'value': 'viudo (a)', 'text': 'Viudo' },
      ]
    },
    /**
     * @param {Array} datos
     * @param {String} value
     * @param {String} text
     * @param {String|Array} description
     * @return {Array}
     */
    setTransform(datos, value, text, description) {
      return setTransform(datos, value, text, description)
    },
    /**
     *
     * @param {Number} value
     * @param {Object} form
     */
    determineUserType(value, form) {
      if (this.checkVariable(value)) {
        const newValue = this.getValueNumber(value)
        this.contractorCreation = (newValue === 2 || false)

        // Sin cuenta
        if (this.contractorCreation === true) {
          this.$set(form, 'password', '')
          this.$set(form, 'password_confirmation', '')
          this.$set(form, 'user_groups', null)
          this.$set(form, 'user_groups_id', [])
        }
      }
    },
    /**
     *
     * @param {Event} event
     * @param {Object} form
     */
    clearUserGroups(event, form) {
      const element = event.target
      if (this.checkVariable(element) && parseInt(element.value) !== 13) {
        this.$set(form, 'user_groups', null)
        this.$set(form, 'user_groups_id', [])
      }
    },
    /**
     * @param {Object} user
     * @param {Object} form
     */
    createUserGroupListFormat(user, form) {
      if (this.isArray(user.grupo_usuarios) && this.getAmountOfKeys(user.grupo_usuarios) > 0) {
        const arrUserGroup = this.setTransform(user.grupo_usuarios, 'usuario_id', 'datos_usuario.name', ['datos_usuario.email'])
        const mapUserGroup = this.map(arrUserGroup, user => {
          return { 'value': user.usuario_id, 'text': user.name }
        })
        this.$set(form, 'user_groups_id', mapUserGroup)
      }
    },
    createLawyerListFormat(lawyers, form) {
      if (this.isArray(lawyers) && this.getAmountOfKeys(lawyers) > 0) {
        const arrLawyers = this.setTransform(lawyers, 'id', 'persona.full_name', ['persona.email'])
        const mapUserGroup = this.map(arrLawyers, user => {
          return { 'value': user.id, 'text': user.full_name }
        })
        this.$set(form, 'abogados_usuarios_id', mapUserGroup)
      }
    },
    /**
     * @param {String} action
     * @param {Array} data
     * @param {String} message
     */
    captureDataToRevert(action, data, message, alternativeUrl = null) {
      captureDataToRevert(action, data, message, alternativeUrl)
    },
    /**
     * @param {String} url
     * @param {Array} request
     * @return {Promise}
     */
    async revertAction(url, request) {
      return axios.patch(url, request)
        .then(response => {
          if (this.checkVariable(response, response.data)) {
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
            this.$root.$emit('triggerSwitchRevertDataToast', false)
          }
        })
    },
    /**
     * Crea un arreglo de objetos 'columna' y 'valor' de un registro para revertir una acción
     * @param {Object} record
     * @param {Array} columns
     * @returns {Array}
     */
    getColumnsAndValuesArrayToRevert(record, columns) {
      const columnsAndValues = []

      for (const column of columns) {
        const objectColumn = {
          column,
          value: record[column],
        }

        columnsAndValues.push(objectColumn)
      }

      return columnsAndValues
    },
    /**
     * Crea un arreglo de datos del objeto Collection del componente Filterable, para revertir acciones masivas.
     * @param {Array} idsMarked
     * @param {Object} collection
     * @param {Array} columnsToAsign
     * @param {String} indexColumn
     * @returns {Array}
     */
    createRecordsArrayToRevertFromFilterableCollection(idsMarked, collection, columnsToAsign, indexColumn = 'id') {
      const recordsToRevert = []
      if (this.checkVariable(collection.data) && this.isArray(idsMarked) && this.getAmountOfKeys(idsMarked) > 0) {
        for (const key in idsMarked) {
          const id = idsMarked[key]
          const record = this.getTheFirstOccurrenceByKey(collection.data, id, 'id')
          if (this.checkVariable(record)) {
            const columns = this.getColumnsAndValuesArrayToRevert(record, columnsToAsign)
            const object = { id: record[indexColumn], columns }
            recordsToRevert.push(object)
          }
        }
      } else if (this.checkVariable(collection.data) && this.isArray(idsMarked) && this.getAmountOfKeys(idsMarked) === 0) {
        for (const key in collection.data) {
          const data = collection.data[key]
          const columns = this.getColumnsAndValuesArrayToRevert(data, columnsToAsign)
          const object = { id: data[indexColumn], columns }
          recordsToRevert.push(object)
        }
      }

      return recordsToRevert
    },
    /**
     * @param {Array} datos
     * @param {...Array} values
     * @param {Function} comparator
     * @return {Array}
     */
    differenceWith(datos, values, comparator) {
      return differenceWith(datos, values, comparator)
    },
    /**
     * @param {Array} datos
     * @param {Array} values
     * @param {Boolean} beginning
     * @return {Array}
     */
    compareArrangementWith(datos, values, beginning) {
      return compareArrangementWith(datos, values, beginning)
    },
    /**
     * @param {string} string
     * @param {String} target
     * @param {Number} position
     * @return {Boolean}
     */
    endsWith(string, target, position) {
      return endsWith(string, target, position)
    },
    /**
     * @param {Array} datos
     * @param {...Array} values
     * @param {Function} iteratee
     * @return {Array}
     */
    sortedIndexBy(datos, values, iteratee) {
      return sortedIndexBy(datos, values, iteratee)
    },
    /**
     * @param {Array|Object} datos
     * @param {Function|Array} iteratees
     * @return {Array}
     */
    sortBy(datos, iteratees) {
      return sortBy(datos, iteratees)
    },
    /**
     * @param {Array|Object} datos
     * @param {Array|Function|Object} iteratees
     * @param {Array} orders
     * @return {Array}
     */
    orderBy(datos, iteratees, orders) {
      return orderBy(datos, iteratees, orders)
    },
    /**
     * @param {Array} datos
     * @return {String|Object}
     */
    getTheFirstWithout(datos) {
      return getTheFirstWithout(datos)
    },
    clearFormErrors(form) {
      const errors = form.errors

      if (this.checkVariable(errors)) {
        errors.clear()
      }
    },
    /**
     * @param {String} currentDate
     * @return {Object}
     */
    startOfHour(currentDate) {
      return startOfHour(currentDate)
    },
    /**
     * @param {String} currentDate
     * @return {Object}
     */
    endOfHour(currentDate) {
      return endOfHour(currentDate)
    },
    /**
     * @param {Number} length
     * @return {Array}
     */
    footerTableInvoices(length) {
      if (length > 0) {
        const footers = new Array(length)
        footers[2] = this.invoiceTotal

        return footers
      }

      return []
    },
    /**
     * @param {Number} length
     * @param {Number} index
     * @return {Array}
     */
    footerTableChecks(length, index) {
      if (length > 0) {
        const footers = new Array(length)
        footers[index] = this.checksTotal

        return footers
      }

      return []
    },
    /**
     * @param {*} value
     * @return String
     */
    getTypeof(value) {
      return getTypeof(value)
    },
    /**
     * @param {String} moduleName
     * @return {void}
     */
    setModuleIndicator(moduleName) {
      this.$store.dispatch('setModuleIndicator', moduleName)
    },
    /**
     * @return {void}
     */
    getUserSettings() {
      if (this.authUser && this.authUser.id) {
        this.$store.dispatch('getUserSettings', this.authUser.id)
      }
    },
    /**
     * @param {Object} datos
     * @param {Array|string} path
     * @return {Boolean}
     */
    unset(datos, path) {
      return unset(datos, path)
    },
  },
}

const Component = Vue.extend({
  name: 'new-helper',
  mixins: [helperMixin],
})

export default Component
